var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#0e314c"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#b05281",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0e314c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#b05281",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#b05281",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#fbae3c",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#b05281",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0e314c",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 378.6C-38.3 369.6 -76.6 360.7 -113.7 350C-150.8 339.3 -186.8 326.9 -222.5 306.3C-258.2 285.7 -293.7 256.9 -301.8 219.2C-309.8 181.6 -290.4 135.1 -298.6 97C-306.9 59 -342.7 29.5 -378.6 0L0 0Z",
    fill: "#594678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 252.4C-25.5 246.4 -51.1 240.5 -75.8 233.3C-100.6 226.2 -124.5 217.9 -148.4 204.2C-172.2 190.5 -195.8 171.3 -201.2 146.2C-206.5 121.1 -193.6 90 -199.1 64.7C-204.6 39.3 -228.5 19.7 -252.4 0L0 0Z",
    fill: "#ef7064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 126.2C-12.8 123.2 -25.5 120.2 -37.9 116.7C-50.3 113.1 -62.3 109 -74.2 102.1C-86.1 95.2 -97.9 85.6 -100.6 73.1C-103.3 60.5 -96.8 45 -99.5 32.3C-102.3 19.7 -114.2 9.8 -126.2 0L0 0Z",
    fill: "#fbae3c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -378.6C44 -380.5 88.1 -382.4 117 -360.1C145.9 -337.7 159.7 -291.2 195.1 -268.6C230.6 -246 287.5 -247.2 303.4 -220.4C319.2 -193.6 293.9 -138.8 299.6 -97.3C305.3 -55.9 341.9 -28 378.6 0L0 0Z",
    fill: "#594678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -252.4C29.4 -253.6 58.7 -254.9 78 -240C97.3 -225.2 106.5 -194.1 130.1 -179.1C153.7 -164 191.7 -164.8 202.3 -146.9C212.8 -129.1 195.9 -92.5 199.7 -64.9C203.5 -37.3 227.9 -18.6 252.4 0L0 0Z",
    fill: "#ef7064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -126.2C14.7 -126.8 29.4 -127.5 39 -120C48.6 -112.6 53.2 -97.1 65 -89.5C76.9 -82 95.8 -82.4 101.1 -73.5C106.4 -64.5 98 -46.3 99.9 -32.4C101.8 -18.6 114 -9.3 126.2 0L0 0Z",
    fill: "#fbae3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.811dd9a779885354768a459df9604a62.svg";
export { ForwardRef as ReactComponent };